
const translations = {

  en: {
    menuline: {
      about: 'About us',
      gallery : "Gallery",
      services : "Services",
      contacts : "Contacts"
    },
    service : {
      mainTitle : "Services",
      titles : ["Cargo transportation for customers", "Freight forwarding for transport companies", "Ferry tickets"]
    },
    tickets : {
      mainTitle : "Ferry tickets",
      top : [
        ['Annually', "60000 +", 'ferry tickets'],
        ['Since 2007', "900 +", "clients of company groups"],
        ['a', '60 +', 'ferry operators'],
      ],
      titles : [
        "",
        "Important to know"
      ],
      paragraphs : [
        "We book more than 60,000 ferry tickets per year within a group of companies. We have been working in this field since 2007. Because of permanent and reliable cooperation, P&O Short Sea Ferries Limited and Scandlines Deutschland GmbH have chosen us as official Baltic States representatives. In 2018, according to Estonian statistics, our group of companies took 2% of Tallinn - Helsinki market, by transferring cargo vehicles by ferries:",

        "Compliance with obligations, the usage of the win-win principle, professionalism and reliability are major factors that determines the success of permanent cooperation with ferry operators.",

        "While working with transport companies that are our clients - first of all, we consider the basic needs of the customer and then we offer the most price and time wise effective ferry transfer options. During the company’s working history up to 2016, 18 clients were lost due to employees wrong decisions. For this reason, we confirmed internal group of companies’ customer service standards, that are now followed by all of our staff members.",

        "30% of our customers are using our online ferry booking system, which allows customers to receive ferry confirmations in real time. We are working for the client, so we can be contacted 7/24/365. If you would like to give a feedback about the quality of our services, please send an email to an address info@tvintransus.lt or call +37067463716. We always take into consideration the requests of our customers - this is the key to success.",

        "Required information for ferry booking:"

      ],
      listItems : [
        'vehicle type, numbers;',
        'date of sailing;',
        'number of drivers;',
        'temperature for the temperature-controlled cargo;',

        "UN number, hazard class, packing class, cargo title and weight, dangerous goods declaration - if you are transporting dangerous goods (ADR). Important information: when using a ferry for a vehicle with a limited quantity of dangerous goods, the driver must always submit dangerous goods declaration and inform about the dangerous goods in advance before booking the ferry ticket; according to the requirements of the ferry, additional information may be required: driver's data, cargo weight, type.",

        ''
      ],
      img : "https://i.imgur.com/388UvXn.png"
    },
    companies : {
      mainTitle : "Freight forwarding for transport companies",
      titles : [
        'Offered full loads',
        'Partial loads are offered'
      ],
      paragraphs : [
        "For transport companies we offer cargo transportation in Western and Eastern Europe. When transporting our cargo we can assure:",
        "For new partners as a guarantee of reliability, we can offer references from the companies that work with us. Achievements of the company are the Gazelle award of Klaipeda district, annual growth of the turnover of the company by 20%, several years in a row we are on the list of 5% most stable companies of Creditreform Lietuva UAB:",
        "Advantages of working with UAB Tvintransus:",
        "We offer partial loads for transport companies in the Baltic States, EU and CIS countries."
      ],
      listItems : [
        ['operative cargo loading, unloading;', 'prompt submission of information;', 'payment at the agreed time.'],
        ['In 2011 UAB Tvintransus became the fastest growing “gazelle” in the district of Klaipeda. The estimate is based on the annual growth of turnover.', "According to Creditreform Lietuva UAB, recently, we take a place on the list of 5% most stable companies in Lithuania according to Creditreform Lietuva UAB. The evaluation is based on Creditreform Lietuva UAB methodology and an analysis of the company's position in market also development in the last few years."],
        ['Your transport services will be paid quickly and reliably - it is guaranteed by our good credit history.', 'If there are ferries or bridges on the road during the transportation, to our carriers we offer the tickets for a competitive price.', 'Long-term partnership: transport companies gets priority for our cargo offers, according to the number of cargoes transported by UAB Tvintransus.']
      ]
    },
    about : {
      mainTitle : "About us",
      paragraphs : [
        "UAB Tvintransus provides transport services to transport companies and freight customers. Proficiency, reliability, professionalism, simplicity, economy are 5 main principles that are followed by all the members of the company. We work for the client, so you can contact us 7/24/365. Based on permanent and reliable cooperation, P&O Short Sea Ferries Limited and Scandlines Deutschland GmbH companies chose us as an official representatives of the Baltic States.",

        "2011 UAB Tvintransus became the fastest growing “gazelle” in the district of Klaipeda. The rating is based on the annual growth of turnover. According to Creditform Lietuva UAB recently, we take a place on the list of 5% most stable companies in Lithuania. The evaluation is based on Creditreform Lietuva UAB methodology and an analysis of the company's position in market also development, in the last few years.",

        "Every year UAB Tvintransus turnover increases by 20%. We care about nature, since 2016 we reduced paper consumption by 90% by moving majority of our information to electronic database. We care about children, in 2017 we fulfilled children's Christmas wishes.",

        ''


      ]
    },
  contacts : {
    title : 'Get in touch',
    street : "Vytauto str. 71",
  },
  customers: {
    mainTitle : "Cargo transportation for customers",
    top : [
      ['Since 2017', "Reliability", 'among the 5% of most stable companies in Lithuania'],
      ['2011', "Klaipeda's Gazelle", ],
      ['Annual', '20% +', 'turnover growth'],
    ],
    titles: [
      'Full loads: toutliners, refrigerated semi-trailers, land and sea transport',
      'Partial loads',
      'Important to know'
    ],
    paragraphs: [
      "Tvintransus UAB provides local and international full cargo transportation services to customers. We convey full loads from/to EU and the Baltic States, inside the Baltic States, also including the transportation to/from CIS countries. We transport loads with toutliners, refrigerated semi-trailers, as well dangerous, all classes of ADR cargoes. We work with Lithuanian and EU trade and manufacturing companies. We always offer a service that satisfies customer's wishes for a competitive price, this is how we increase our client circle. Annual increasment of company's groups turnover  reaches 20%.",

      "",

      "Tvintransus UAB provides local and international partial cargo transportation services to customers. We carry partial cargoes to/from EU and the Baltic States.",

      "Partial cargo transportation helps to save money as it is not necessary to order the entire vehicle. Partial loads are conveyed directly, cargoes of several customers are loaded into one vehicle or via terminal afterwards cargo is transported from the customer to the terminal, where it is collected with other cargoes and transported to the terminal of the destination country and from there delivered directly to the customer.",

      "In order to submit an order for the carriage of cargo, the following information is required:"
    ],
    listItems : [
      'places and dates of loading, unloading;',
      'cargo title, dimensions, weight;',
      'for the temperature-controlled cargo, required temperature;',
      'for dangerous goods: UN number, class, packing class.'
    ]
  },
  },




  lt: {
    menuline: {
      about: 'Apie mus',
      gallery : "Galerija",
      services : "Paslaugos",
      contacts : "Kontaktai"
    },
    service : {
      mainTitle : "Paslaugos",
      titles : ["Krovinių transportavimas užsakovams", "Krovinių pervežimas transporto įmonėms", "Keltų bilietai"]
    },
    tickets : {
      mainTitle : "Keltų bilietai",
      top : [
        ['Kasmet', "60000 +", 'keltų bilietų'],
        ['Nuo 2007 m.', "900 +", "įmonių grupės klientų"],
        ['a', '60 +', 'Keltų operatorių'],
      ],
      titles : [
        "Mūsų krovininių transporto priemonių keltų rinkos dalis Talino-Helsinkio rinkoje 2018",
        "Svarbu žinoti"
      ],
      paragraphs : [
        "Įmonių grupėje per metus užsakome virš 60 000 keltų bilietų. Dirbti šioje srityje pradėjome nuo 2007 metų. Dėl ilgalaikio patikimo bendradarbiavimo, P&O Short Sea Ferries Limited ir Scandlines Deutschland GmbH įmonės pasirinko mus oficialiais atstovais Baltijos šalims. 2018 m. pagal Estijos statistinius duomenis, mūsų įmonių grupės užėmė 2% Talino -Helsinkio transporto priemonių perkėlimo keltais rinkos:",

        "Įsipareigojimų laikymąsis, win-win principo siekiamybė, profesionalumas ir patikimumas - pagrindiniai ilgalaikio bendradarbiavimo su keltų operatoriais sėkmės veiksniai.",

        "Dirbdami su klientais- transporto įmonėmis- pirmiausiai atsižvelgiame į pagrindinius kliento poreikius ir pasiūlome optimaliausius keltais persikėlimo variantus kainos ir laiko atžvilgiu. Per visą įmonės grupių darbo istoriją iki 2016 metų, dėl darbuotojų neteisingų sprendimų buvo prarasta 18 klientų. Dėl šios priežasties buvo patvirtinti vidiniai įmonių grupės klientų aptarnavimo standartai, kurių laikosi visi darbuotojai.",

        "30% klientų naudojasi mūsų sukurta keltų užsakymų sistema, kuri leidžia gauti keltų patvirtinimo atsakymus realiu laiku. Mes dirbame klientui, todėl su mumis galima susisiekti 7/24/365. Jei norite palikti atsiliepimą apie mūsų suteiktos paslaugos kokybę, prašome rašyti el.adresu: info@tvintransus.lt arba skambinti telefonu : +37067463716. Visada atsižvelgiam į klientų pageidavimus, nes tai mūsų tobulėjimo pagrindas.",

        "Kelto užsakymui reikalinga informacija:"

      ],
      listItems : [
        'transporto priemonės tipas, numeriai;',
        'plaukimo data;',
        'vairuotojų skaičius;',
        'temperatūra, jei reikalingas temperatūrinis režimas;',

        'un numeris, pavojingumo klasė, pakavimo klasė, krovinio pavadinimas ir svoris, pavojingo krovinio deklaracija- jei krovinys pavojingas (ADR). Svarbu žinoti: naudojant keltą transporto priemonei su mažu kiekiu pavojingo krovinio (limited quantity), vairuotojas visada privalo pateikti pavojingo krovinio deklaraciją ir informuoti mus apie pavojingą krovinį iš anksto, prieš užsakant kelto bilietą;',

        'pagal kelto reikalavimus, galimai reikalinga papildoma informacija: vairuotojo duomenys, krovinio svoris, tipas.'
      ],
      img : "https://i.imgur.com/hmXstfj.png"
    },
    customers: {
      mainTitle : "Krovinių transportavimas užsakovams",
      top : [
        ['Nuo 2017 m.', "Patikimumas", 'tarp 5% stabiliausių Lietuvos įmonių'],
        ['2011 m.', "Klaipėdos Gazelė", ],
        ['Kasmetinis', '20% +', 'apyvartos augimas'],
      ],
      titles: [
        'Pilni kroviniai:  tentiniais sunkvežimiais, šaldytuvinėmis puspriekabėmis, sausumos ir jūros transportu',
        'Daliniai kroviniai',
        'Svarbu žinoti'
      ],
      paragraphs: [
        'Tvintransus UAB teikia vietinių ir tarptautinių pilnų krovinių gabenimo paslaugas užsakovams. Gabename pilnus krovinius iš/į ES ir Baltijos šalis, Baltijos šalyse, taip pat vežame krovinius į/iš NVS šalis. Gabename krovinius tentinėmis, šaldytuvinėmis puspriekabėmis, taip pat gabename ir pavojingus visų klasių ADR krovinius.',

        "Dirbame su Lietuvos ir ES šalių prekybos ir gamybos įmonėmis. Visada siūlome kliento poreikius atitinkančią paslaugą už konkurencingą kainą - taip auginame klientų ratą. Metinis įmonių grupių apyvartos augimas - 20%.",

        "Tvintransus UAB teikia vietinių ir  tarptautinių dalinių krovinių gabenimo paslaugas užsakovams. Gabename dalinius krovinius iš/į ES ir Baltijos šalis, Baltijos šalyse.",

        "Dalinių krovinių gabenimas padeda sutaupyti, nes užsakoma ne visa transporto priemonė. Daliniai kroviniai vežami tiesiogiai: kelių užsakovų kroviniai pakraunami į vieną transporto priemonę arba per terminalą: iš užsakovo krovinys vežamas į terminalą, kur komplektuojamas su kitais kroviniais ir pervežamas į paskirties šalies terminalą, iš kurio pristatomas tiesiogiai užsakovui.",

        "Norint pateikti krovinio užsakymą krovinio pervežimui, reikalinga nurodyti informaciją:"
      ],
      listItems : [
        'pasikrovimo, išsikrovimo vietos ir datos;',
        'krovinio pavadinimas, išmatavimai, svoris;',
        'kroviniui su temperatūriniu režimu- reikalinga temperatūra;',
        'pavojingam kroviniui: UN numeris, klasė, pakavimo klasė.'
      ]
    },
    companies : {
      mainTitle : "Krovinių pervežimas transporto įmonėms",
      titles : [
        'Siūlomi pilni kroviniai',
        'Siūlomi daliniai kroviniai'
      ],
      paragraphs : [
        "Transporto įmonėms siūlome pervežti krovinius Vakarų ir Rytų Europoje. Vežant mūsų krovinius užtikriname:",
        "Naujiems partneriams, kaip patikimumo garantą, galime pasiūlyti su mumis dirbančių įmonių rekomendacijas. Įmonės pasiekimai:  laimėta Klaipėdos apskrities Gazelė, kasmetinis įmonių grupės apyvartos augimas 20 %, keleri metai iš eilės patenkame į Creditreform Lietuva UAB  5% stabiliausių įmonių sąrašą:",
        "Darbo su UAB Tvintransus privalumai:",
        "Transporto įmonėms siūlome dalinius krovinius Baltijos, ES ir NVS šalyse."
      ],
      listItems : [
        ['operatyvų krovinio pakrovimą, iškrovimą;', 'operatyvų informacijos pateikimą;', 'sutartą laiku atsiskaitymą.'],
        ['2011 m. UAB Tvintransus tapo sparčiausiai augusia Klaipėdos apskrities „Gazele";. Įvertinimas atliktas remiantis kasmetiniu apyvartos augimu.', 'Pastaraisiais metais patenkame į 5% Lietuvos stabiliausių įmonių sąrašą, Creditreform Lietuva UAB duomenimis. Įvertinimas atliekamas remiantis Creditreform Lietuva UAB metodika ir kelių metų įmonės padėties rinkoje ir vystymosi analize.'],
        ['Jūsų transporto paslaugos bus greitai ir patikimai apmokėtos - tai garantuoja mūsų geras kreditingumas;', 'Jei krovinio pervežimo kelyje yra keltų arba tiltų, transporto įmonėms , vežančioms mūsų krovinį pasiūlome tiltus arba keltus konkurencinga kaina. Patikima verslo partnerystė su keltų ir tiltų operatoriais  nuo 2007 metų suteikia galimybę vežėjams pasiūlyti konkurencingas keltų ir tiltų kainas Vakarų Europoje Ro-Ro, Ro-Pax keltuose. Esame  P&O Short Sea Ferries Limited ir Scandlines Deutschland GmbH oficialūs atstovai Baltijos šalims.', 'Ilgalaikė partnerystė - transporto įmonės, krovinių pasiūlymų pirmenybę gauna pagal  UAB Tvintransus išvežtų krovinių skaičių.']
      ]
    },
    about : {
      mainTitle : "Apie mus",
      paragraphs : [
        "UAB Tvintransus teikia transporto paslaugas transporto įmonėms ir krovinius vežantiems klientams. Patirtis, patikimumas, profesionalumas, paprastumas, pigumas- 5P principai, kuriais vadovaujasi visa įmonių grupės darbuotojų komanda. Dirbame klientui, todėl su mumis galima susisiekti 7/24/365. Dėl ilgalaikio patikimo bendradarbiavimo, P&O Short Sea Ferries Limited ir Scandlines Deutschland GmbH įmonės pasirinko mus oficialiais atstovais Baltijos šalims.",

        '2011 m. UAB Tvintransus tapo sparčiausiai augusia Klaipėdos apskrities „Gazele". Įvertinimas atliktas remiantis kasmetiniu apyvartos augimu.',

        'Pastaraisiais metais patenkame į 5% Lietuvos stabiliausių įmonių sąrašą, Creditreform Lietuva UAB duomenimis. Įvertinimas atliekamas remiantis Creditreform Lietuva UAB metodika ir kelių metų įmonės padėties rinkoje ir vystymosi analize.',

        'Kasmet UAB Tvintransus apyvarta auga 20%. Mums rūpi gamta- nuo 2016 m. sumažinome 90 % popieriaus sunaudojimą, didžiąją dalį informacijos perkėlę į elektroninę erdvę. Mums rūpi vaikai- 2017m. pildėme Kalėdines vaikų svajones.'


      ]
    },
    contacts : {
      title : 'Susisiekite',
      street : "Vytauto g. 71",
    }
  }

}

export default translations;



// WEBPACK FOOTER //
// ./src/lang/translations.js